import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { rootApi } from './rootApi.js'
import { sessionSlice } from './session.slice.js'

export const store = configureStore({
  reducer: {
    [rootApi.reducerPath]: rootApi.reducer,
    session: sessionSlice.reducer,
  },
  middleware: (getDefault) => getDefault().concat(rootApi.middleware),
})

/** Refetch on reconnect and on window focus. */
setupListeners(store.dispatch)

export type AppStore = typeof store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

/** Typed, so no screen ever writes `useSelector((s: any) => …)`. */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()

export { rootApi, TAGS, listTags } from './rootApi.js'
export type { Tag } from './rootApi.js'
